import React from 'react';
import { Link } from 'react-router-dom';
import { formatDate, truncateText } from '../../utils/helpers';
import { extractPlainText } from '../../utils/htmlSanitizer';

function ContentCard({ content }) {
  const contentUrl = `/content/${content.slug || content.id}`;

  return (
    <article className="content-card">
      <div className="content-card-header">
        <div className="card-title-row">
          <h3 className="content-card-title">
            <Link to={contentUrl} className="content-link">
              {content.title}
            </Link>
          </h3>
          
          <div className="content-meta-compact">
            <span className={`content-type-badge content-type-${content.type}`}>
              {content.type}
            </span>
            <span className="meta-separator">•</span>
            <span className="content-author">by {content.authorDisplayName}</span>
            <span className="meta-separator">•</span>
            <span className="content-date">{formatDate(content.publishedAt)}</span>
            {content.viewCount > 0 && (
              <>
                <span className="meta-separator">•</span>
                <span className="content-views">{content.viewCount} views</span>
              </>
            )}
          </div>
        </div>
      </div>
      
      {content.excerpt && (
        <div className="content-card-excerpt">
          <p>{truncateText(content.excerpt, 150)}</p>
        </div>
      )}
      
      {!content.excerpt && (
        <div className="content-card-excerpt">
          <p>{truncateText(extractPlainText(content.body), 150)}</p>
        </div>
      )}
      
      <div className="content-card-footer">
        <div className="content-card-tags">
          {content.tags && content.tags.length > 0 && content.tags.map((tag, index) => (
            <span key={index} className="content-tag">
              {tag}
            </span>
          ))}
        </div>
        
        <Link to={contentUrl} className="read-more-btn">
          Read More →
        </Link>
      </div>
    </article>
  );
}

export default ContentCard;